export const TEST_ID = 'applicationsPage';
